export const useAutoExpand = () => {
  const autoExpand = (e) => {
    e.target.style.height = "auto";
    e.target.style.height = e.target.scrollHeight + "px";
  };

  return autoExpand;
};
